/**
 * Status da NF-e de saída (status principais).
 * Espelha status_nfe_saida (db_repo_dfe) e StatusNFeSaidaEnum (API RepoDFe), com os mesmos valores.
 */
export enum StatusNFeSaidaEnum {
  AguardandoTransmissao = 1,
  Autorizada = 2,
  Rejeitada = 3,
  Cancelada = 4,
  Denegada = 5,
  EmTransmissao = 6,
}
